import styled from 'styled-components';

export const BodyManager = styled.div<{ hasBoard: boolean }>`
  display: flex;
  justify-content: space-between;
  .list {
    padding: 0;
    text-align: center;
    width: ${(props) => (props.hasBoard ? 'auto' : '100%')};
    max-width: ${(props) => (props.hasBoard ? '200px' : '100%')};
    input {
      margin-bottom: 10px;
      padding: 5px;
      &:focus {
        outline: none;
      }
    }
    ul {
      padding-left: 20px;
    }
    li {
      list-style-type: none;
      color: #0093dd;
      cursor: pointer;
    }
  }
  main {
    width: ${(props) => (props.hasBoard ? 'calc(100% - 250px)' : '0')};
  }
`;

export const Info = styled.div`
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  height: calc(100vh - 188px);
`;

export const TrackingWrapper = styled.div`
  border-top: 1px solid #dedede;
  padding: 30px;
  min-height: calc(100vh - 188px);
  padding-bottom: 60px;
`;
